module.exports = __webpack_public_path__ + "img/poster-image-01.431bfb1a.jpg";